import {
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  Tooltip,
} from "@fluentui/react-components";
import { useSharedDialogTabStyles } from "theme/sharedStyles";
import { IDialogTabsProps } from "./DialogTabs.types";

export const DialogTabs = (props: IDialogTabsProps): JSX.Element => {
  const tabStyles = useSharedDialogTabStyles();
  const { tabs, activeTab, onTabClick } = props;

  const handleTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
    onTabClick(data.value as string);
  };

  return (
    <div className={tabStyles.stickyWrapper}>
      <TabList
        selectedValue={activeTab}
        onTabSelect={handleTabSelect}
        className={tabStyles.tabList}
      >
        {tabs.map((tab) =>
          tab.tooltip ? (
            <Tooltip
              key={tab.key}
              content={tab.tooltip}
              relationship="description"
            >
              <Tab
                id={`tab-${tab.key}`}
                value={tab.key}
                className={tabStyles.tab}
              >
                {tab.label}
              </Tab>
            </Tooltip>
          ) : (
            <Tab
              key={tab.key}
              id={`tab-${tab.key}`}
              value={tab.key}
              className={tabStyles.tab}
            >
              {tab.label}
            </Tab>
          ),
        )}
      </TabList>
    </div>
  );
};
